var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',[_c('div',{staticClass:"ml-auto"},[_c('span',{staticClass:"mr-1"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" "),_c('a',{staticStyle:{"text-decoration":"none","color":"#4f5d73"},attrs:{"href":"https://www.paynet.my/","target":"_blank"}},[_vm._v("PayNet 200801035403 (836743-D)")]),_vm._v(". All Rights Reserved ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }